import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Close.js';

export interface DeleteDraftConfirmModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  formTitle?: string;
  'data-testid'?: string;
}

export const DeleteDraftConfirmModal = ({
  open,
  setOpen: _setOpen,
  onConfirm,
  onCancel,
  isLoading = false,
  formTitle,
  'data-testid': dataTestId = 'delete-draft-confirm-modal',
}: DeleteDraftConfirmModalProps) => (
  <Dialog
    open={open}
    onClose={!isLoading ? onCancel : undefined}
    aria-labelledby="delete-draft-dialog-title"
    aria-describedby="delete-draft-dialog-description"
    data-testid={dataTestId}
  >
    <DialogTitle component="div">
      <Typography variant="h6" component="h2" id="delete-draft-dialog-title">
        Delete draft
      </Typography>
      <IconButton
        aria-label="Close"
        onClick={onCancel}
        disabled={isLoading}
        size="small"
        color="inherit"
        data-testid={`${dataTestId}-close`}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      {formTitle ? (
        <>
          <DialogContentText id="delete-draft-dialog-description">
            Are you sure you want to delete the following item?
          </DialogContentText>
          <Typography fontWeight={600} sx={{ mt: 1 }}>
            {formTitle}
          </Typography>
        </>
      ) : (
        <DialogContentText id="delete-draft-dialog-description">
          Are you sure you want to delete the following item?
        </DialogContentText>
      )}
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'space-between' }}>
      <Button
        variant="outlined"
        onClick={onCancel}
        disabled={isLoading}
        data-testid={`${dataTestId}-cancel`}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="destructive"
        onClick={onConfirm}
        disabled={isLoading}
        autoFocus
        data-testid={`${dataTestId}-confirm`}
        startIcon={
          isLoading ? <CircularProgress size={16} color="inherit" /> : undefined
        }
      >
        {isLoading ? 'Deleting...' : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);
